import React, { useContext, useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { CreditCard, Truck, User, Home, Phone, Mail, ArrowLeft, CheckCircle, XCircle } from 'lucide-react';
import axios from "axios";
import { product_uri, user_uri } from '../../../../uri';
import { Checkbox, Spinner, useToast } from '@chakra-ui/react';
import { AuthContext } from '../../../../context/auth';
import { Radio } from 'antd';

const Checkout = () => {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [status, setStatus] = useState(false);
  const [paymentCheck, setPaymentCheck] = useState(false);
  const [paymentData, setPaymentData] = useState([]);
  const [qpay, setQpay] = useState({});
  const [shippingDetails, setShippingDetails] = useState({
    fullName: '',
    address: '',
    phone: '',
    email: '',
    notes: ''
  });
  const [deliveryType, setDeliveryType]=useState('irj');
  const [addressId, setAddressId]=useState();
  const [address, setAddress]=useState([]);
  
  const toast = useToast();
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    fetchCartItems();
  }, []);


    useEffect(() => {
      if(deliveryType == 'deliv'){
        getAddress();
      }
    }, [deliveryType]);

    const getAddress = async () => {
      try {
        setLoading(true);
        const res = await axios.get(user_uri + `s/address/get?token=${currentUser}`);
        console.log(res.data)
        setAddress(res.data);
        setLoading(false);
      } catch (err) {
        console.log(err);
        setLoading(false);
        if (err.response && err.response.status === 444) {
          navigate("/login");
        }
      }
    };

  const fetchCartItems = async () => {
    try {
      setLoading(true);
      const res = await axios.get(product_uri + `/cart?user_id=${currentUser}`);
      setCartItems(res.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
      if (err.response && err.response.status === 444) {
        navigate("/login");
      }
    }
  };

  const verifyPayment = async () => {
    try {
      setProcessing(true);
      const res = await axios.post(product_uri + `/verify-payment`, {
        user_id: currentUser,
        items: cartItems.map(item => ({
          product_id: item.product.id,
          quantity: item.quantity,
          size_id: item.size_id,
          color_id: item.color_id
        })),
      });
      
      if (res.status == 200) {
        setPaymentStatus('success');
        // Clear cart after successful payment
        fetchCartItems();
      } else {
        setPaymentStatus('failed');
      }
      setProcessing(false);
    } catch (err) {
      console.log(err);
      setPaymentStatus('failed');
      setProcessing(false);
      toast({
        title: "Төлбөр баталгаажуулахад алдаа гарлаа",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const calculateTotal = () => {
    return cartItems.reduce((total, item) => {
      return total + (item.product.price * item.quantity);
    }, 0);
  };

  const initiatePayment = async () => {
    // Validate form fields
    // if () {
    //   toast({
    //     title: "Мэдээлэл дутуу байна",
    //     description: "Бүх талбарыг бөглөнө үү",
    //     status: "warning",
    //     duration: 3000,
    //     isClosable: true,
    //   });
    //   return;
    // }

    try {
      setProcessing(true);

      let a;
      if(deliveryType === 'irj'){
        a=1;
      }else{
        if(addressId){
          a=addressId;
        }else{
          return toast({
            title: "Гэрийн хаяг сонгоогүй байна",
            description: "Гэрийн хаяг нэмсэн эсэхээ шалгаарай",
            status: "warning",
            duration: 3000,
            isClosable: true,
          });
        }
      }
      const res = await axios.post(product_uri + `/initiate-payment`, {
        user_id: currentUser,
        // items: cartItems.map(item => ({
        //   product_id: item.product.id,
        //   quantity: item.quantity,
        //   size_id: item.size_id,
        //   color_id: item.color_id
        // })),
        total_amount: calculateTotal(),
        address_id: a
      });

      if(res.status == 207){
        setProcessing(false);
          return toast({
          title: "Та өмнөх захиалгаа дуусгана уу !",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }

      if(res.status == 209){
        setProcessing(false);
          return toast({
          title: "Барааны үлдэгдэл хүрэхгүй байна !",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
      
      if (res.data) {
        console.log(res.data)
        setQpay(res.data.data);
        setPaymentData(res.data.data.urls);
        setStatus(true);
        // Redirect to bank payment page
        // window.location.href = res.data.payment_url;
      } else {
        throw new Error("Төлбөрийн холбоос байхгүй байна");
      }
      
      setProcessing(false);
    } catch (err) {
      console.log(err);
      setProcessing(false);
      toast({
        title: "Төлбөр эхлүүлэхэд алдаа гарлаа",
        description: err.response?.data?.message || "Дахин оролдоно уу",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const continueShopping = () => {
    navigate('/product');
  };

  const handleLink = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
    setPaymentCheck(true);
  };
  

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spinner size="xl" color="blue.500" />
      </div>
    );
  }

  if (processing) {
    return (
      <div className="flex flex-col justify-center items-center h-64">
        <Spinner size="xl" color="blue.500" mb={4} />
        <p className="text-lg">Төлбөр хийгдэж байна, түр хүлээнэ үү...</p>
      </div>
    );
  }

  if (paymentStatus === 'success') {
    return (
      <div className="max-w-3xl mx-auto mt-10 p-6 bg-white rounded-lg shadow-md">
        <div className="flex flex-col items-center text-center">
          <CheckCircle size={64} className="text-green-500 mb-4" />
          <h1 className="text-2xl font-bold mb-2">Худалдан авалт амжилттай!</h1>
          <p className="text-gray-600 mb-6">Таны захиалга амжилттай бүртгэгдлээ. Бид таньтай удахгүй холбогдох болно.</p>
          <button 
            onClick={continueShopping}
            className="bg-red-600 text-white px-6 py-2 rounded-md font-medium hover:bg-red-700 transition"
          >
            Үргэлжлүүлэн худалдан авах
          </button>
        </div>
      </div>
    );
  }

  if (paymentStatus === 'failed') {
    return (
      <div className="max-w-3xl mx-auto mt-10 p-6 bg-white rounded-lg shadow-md">
        <div className="flex flex-col items-center text-center">
          <XCircle size={64} className="text-red-500 mb-4" />
          <h1 className="text-2xl font-bold mb-2">Төлбөр амжилтгүй боллоо</h1>
          <p className="text-gray-600 mb-6">Төлбөр хийхэд алдаа гарлаа. Дахин оролдоно уу.</p>
          <button 
            onClick={() => setPaymentStatus(null)}
            className="bg-red-600 text-white px-6 py-2 rounded-md font-medium hover:bg-blue-700 transition"
          >
            Дахин оролдох
          </button>
        </div>
      </div>
    );
  }

  if (cartItems.length === 0) {
    return (
      <div className="max-w-3xl mx-auto mt-10 text-center p-6 bg-white rounded-lg shadow-md">
        <h2 className="text-xl mb-4">Таны сагс хоосон байна</h2>
        <Link to="/product" className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-red-600">
          Худалдан авалт хийх
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto mt-10 px-4">
      <div className="flex items-center mb-6">
        <Link to="/cart-item" className="flex items-center text-blue-600 hover:text-blue-800">
          <ArrowLeft size={18} className="mr-1" />
          Сагс руу буцах
        </Link>
      </div>
      
      {
        status ?
        <div>
          <div className='flex justify-center my-2'>
            <img
            className='h-40'
              src={`data:image/png;base64,${qpay.qr_image}`}
              alt="QR Code"
            />
          </div>
          <div className='flex justify-center'>
            <button onClick={verifyPayment} className='bg-green-600 p-2 rounded-xl text-white mb-2'>Төлбөр төлөгдсөн эсэхийг шалгах</button>
          </div>
          <div className='grid grid-cols-4 gap-2'>
            {
              paymentData.map((it, index) => {
                return (
                  <div
                    onClick={() => handleLink(it.link)}
                    className='p-2 bg-white rounded-xl cursor-pointer' 
                    key={index}
                  >
                    <div className='flex justify-center'>
                    <img className='w-10 h-10 rounded-xl' src={it.logo} />
                    </div>
                    <h1 className='text-center text-sm'>{it.name}</h1>
                  </div>
                );
              })
            }
          </div>

        </div>
        :
        <>
          <h1 className="text-2xl font-bold mb-6 flex items-center">
            <CreditCard className="mr-2" />
            Төлбөр төлөх
          </h1>
          
          <div className="grid">
            {/* Left Column - Shipping Information */}
            <div>
            <Radio.Group
              onChange={(e) => setDeliveryType(e.target.value)}
              value={deliveryType}
            >
              <Radio value="irj">Ирж авах</Radio>
              <Radio value="deliv">Хүргэлтээр авах</Radio>
            </Radio.Group>

            </div>
            {
              deliveryType === "deliv" &&
              <div className='bg-white p-6 rounded-lg shadow '>
                <h2 className="text-xl font-semibold mb-4">Хүргэлтийн хаяг сонгох</h2>
                <div>
                  <div className="space-y-3">
                    {address.map((address) => (
                      <div 
                        key={address.id}
                        onClick={() => setAddressId(address.id)}
                        className={`p-4 border rounded-md cursor-pointer transition-colors ${
                          addressId === address.id 
                            ? 'bg-blue-50 border-blue-500' 
                            : 'hover:bg-gray-50 border-gray-200'
                        }`}
                      >
                        <div className="flex items-center justify-between">
                          <div>
                            <p className="font-medium">{address.address}</p>
                            <p className="text-sm text-gray-600">
                              {address.city}, {address.district} {address.khoroo}
                            </p>
                          </div>
                          {addressId === address.id && (
                            <div className="text-blue-500">
                              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                              </svg>
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            }
            
            {/* Right Column - Order Summary */}
            <div className="lg:col-span-1">
              <div className="bg-white p-6 rounded-lg shadow">
                <h2 className="text-xl font-semibold mb-4">Захиалгын мэдээлэл</h2>
                
                <div className="border-b pb-4 mb-4">
                  {cartItems.map((item, idx) => (
                    <div key={idx} className="flex justify-between mb-2">
                      <div className="flex-grow">
                        <p className="font-medium">{item.product.name}</p>
                        <p className="text-sm text-gray-600">
                          {item.quantity} ширхэг × {item.product.price.toLocaleString()}₮
                        </p>
                      </div>
                      <div className="text-right">
                        <p className="font-medium">
                          {(item.product.price * item.quantity).toLocaleString()}₮
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
                
                <div className="border-b pb-4 mb-4">
                  <div className="flex justify-between mb-2">
                    <span>Дүн:</span>
                    <span>{calculateTotal().toLocaleString()}₮</span>
                  </div>
                  {/* <div className="flex justify-between">
                    <span>Хүргэлтийн төлбөр:</span>
                    <span>0₮</span>
                  </div> */}
                </div>
                
                <div className="flex justify-between text-lg font-bold mb-6">
                  <span>Нийт дүн:</span>
                  <span>{calculateTotal().toLocaleString()}₮</span>
                </div>
                
                <button 
                  onClick={initiatePayment}
                  disabled={processing}
                  className="w-full bg-red-600 text-white py-3 rounded-md font-medium hover:bg-blue-700 transition disabled:bg-blue-400"
                >
                  Төлбөр төлөх
                </button>
              </div>
            </div>
          </div>
        </>
      }

    </div>
  );
};

export default Checkout;